import React, { useState, useEffect } from "react";
import { db } from "../firebase";
import { collection, query, orderBy, getDocs, doc, getDoc } from "firebase/firestore";
import BookCard from "./BookCard";


export default function ProductCatalog() {
    const [products, setProducts] = useState([]);
    const [loading, setLoading] = useState(true);
    const [filter, setFilter] = useState("All");
    const [dynamicCategories, setDynamicCategories] = useState(["All"]);
    const [digitalCategory, setDigitalCategory] = useState("");

    useEffect(() => {
        async function fetchProducts() {
            try {
                const q = query(collection(db, "products"), orderBy("createdAt", "desc"));
                const snap = await getDocs(q);
                setProducts(snap.docs.map(d => ({ id: d.id, ...d.data() })));

                // Fetch Categories
                const settingsSnap = await getDoc(doc(db, "siteConfig", "general"));
                if (settingsSnap.exists()) {
                    const data = settingsSnap.data();
                    const cats = data.categories || [];
                    setDynamicCategories(["All", ...cats]);
                    setDigitalCategory(data.digitalCategory || "");
                }
            } catch (e) {
                console.error("Error fetching products:", e);
            }
            setLoading(false);
        }
        fetchProducts();
    }, []);

    const filteredProducts = filter === "All" 
        ? products 
        : filter === digitalCategory
            ? products.filter(p => p.isDigital === true)
            : products.filter(p => p.category === filter);

    if (loading) return (
        <div style={{ padding: "80px 0", textAlign: "center", color: "#888" }}>
            Loading catalog...
        </div>
    );

    return (
        <section className="catalog-section" style={{ padding: "80px 20px" }}>
            <div className="container">
                <div style={{ textAlign: "center", marginBottom: 50 }}>
                    <h2 className="section-title">Shop Our Collection</h2>
                    
                    {/* Filters */}
                    <div className="filter-bar" style={{ display: "flex", justifyContent: "center", gap: 12, flexWrap: "wrap", marginTop: 24 }}>
                        {dynamicCategories.map(cat => (
                            <button
                                key={cat}
                                onClick={() => setFilter(cat)}
                                style={{
                                    padding: "8px 20px",
                                    borderRadius: 30,
                                    border: filter === cat ? "none" : "1px solid #ddd",
                                    background: filter === cat ? "#27ae60" : "transparent",
                                    color: filter === cat ? "#fff" : "#555",
                                    cursor: "pointer",
                                    fontWeight: 600,
                                    fontSize: 14,
                                    transition: "all 0.3s"
                                }}
                            >
                                {cat}
                            </button>
                        ))}
                    </div>
                </div>

                <div className="product-grid" style={{ display: "grid", gridTemplateColumns: "repeat(auto-fill, minmax(220px, 1fr))", gap: 40 }}>
                    {filteredProducts.length === 0 ? (
                        <div style={{ gridColumn: "1 / -1", textAlign: "center", padding: "60px 0", color: "#888" }}>
                            No products found in this category.
                        </div>
                    ) : (
                        filteredProducts.map(product => (
                            <BookCard key={product.id} book={product} />
                        ))
                    )}
                </div>
            </div>
        </section>
    );
}
